/**
 * The external dependencies.
 */
import React, { forwardRef } from 'react';
import classNames from 'classnames';

const BaseInput = forwardRef((
	{
		className,
		id,
		placeholder,
		onChange,
		error,
		...props
	},
	ref
) => {
	return (
		<div className={classNames('field', className)}>
            <label
				className="field__label hidden"
				htmlFor={id}
			>
                {placeholder}
            </label>

			<input
					className={classNames({
						'field__input': true,
						'error_border': error
					})}
					id={id}
					ref={ref}
					onChange={onChange}
					placeholder={placeholder}
					{...props}
				/>


		</div>
	);
});


export default React.memo(BaseInput);
